// extracted by mini-css-extract-plugin
export var article = "templates-article--dQKQ+";
export var postTitle = "templates-postTitle--LBLB2";